const anchorClick = (event) => {
    const anchor = event.target;
    const prefix = (anchor.dataset.addressId.indexOf('billing') > -1) ?
        'billing' : 'delivery';
    const target = document.querySelector(
        `#${prefix}_address_manual_form_property_row`
    );

    event.preventDefault();

    setTimeout(() => window.scrollTo({
        top: target.offsetTop,
        left: 0
    }), 0);
};

const init = () => {
    const deliveryAddressAnchors = document.querySelectorAll('.edit-address');

    if (!deliveryAddressAnchors.length) {
        return;
    }

    deliveryAddressAnchors.forEach((anchor) => {
        anchor.removeEventListener('click', event => anchorClick(event));
        anchor.addEventListener('click', event => anchorClick(event));
    });
};

const fixDeliveryEmptyAnchors = () => {
    const addressForm = document.querySelector('form[data-address-form]');

    if (!addressForm) {
        return null;
    }

    const formObserver = new MutationObserver(init);
    formObserver.observe(form, {
        attributes: true,
        childList: true,
        subtree: true
    });
};

export default fixDeliveryEmptyAnchors;
